import Vue from 'vue'
import Toastification, { createToastInterface, POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toastification)

const Toast2 = {
  install (Vue, options) {
    const pluginOptions = {
      timeout: 2000,
      position: POSITION.BOTTOM_LEFT
    }
    const toast = createToastInterface(pluginOptions)

    // Action toast
    Vue.prototype.$toast = function (message, type) {
      if (type) {
        toast[type](message)
      }
      else {
        toast(message)
      }
    }
  }
}

export default Toast2



// WEBPACK FOOTER //
// ./src/plugins/toast2.js